import { combineReducers, configureStore} from '@reduxjs/toolkit'
//import logger from 'redux-logger'
//import thunk from "redux-thunk";

import * as defaults from "../Defaults";

import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import storageSession from 'redux-persist/lib/storage/session';
import storage from 'redux-persist/lib/storage';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import {
    //persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist'

//import { setAutoFreeze } from 'immer'; 
//setAutoFreeze(false);

import authenticationReducer from './features/core/authentication/authenticationSlice'
import tabReducer from './features/core/tab/tabSlice'
import usersReducer from './features/core/users/usersSlice'
import userReducer from './features/core/users/userSlice'
import settingsReducer from './features/core/settings/settingsSlice'
import searchReducer from './features/core/search/searchSlice'
import associationsListReducer from './features/core/associations/associationsSlice';
import associationReducer from './features/core/associations/associationSlice';
import smrReducer from './features/core/smRequests/smrSlice';
import bmsReducer from './features/core/bmStocks/bmsSlice';
import bmrReducer from './features/core/bmStocks/bmsSlice';



const encryptor = encryptTransform({
    secretKey: defaults.app.secret_key as string,
    onError(error) {
        // Handle the error.
    },
});


const authenticationPersistConfig = {
    key: 'authentication',
    storage: storage,
    stateReconciler: hardSet,
    transforms: [encryptor],

    blacklist: ['login']
}
const tabPersistConfig = {
    key: 'tab',
    storage: storageSession,
    stateReconciler: hardSet,
    //transforms: [encryptor]
}
/*const usersPersistConfig = {
    key: 'users',
    storage: storageSession,
    stateReconciler: hardSet,
    //transforms: [encryptor]
}*/
const settingsPersistConfig = {
    key: 'settings',
    storage: storage,
    stateReconciler: hardSet,
    transforms: [encryptor]
}

const searchPersistConfig = {
    key: 'search',
    storage: storageSession,
    stateReconciler: hardSet,
    //transforms: [encryptor]
}

const eventPersistConfig = {
    key: 'event',
    storage: storage,
    stateReconciler: hardSet,
    transforms: [encryptor]
}

const rootPersistConfig = {
    key: 'root',
    storage: storageSession,
    stateReconciler: hardSet,
    //transforms: [encryptor]
}


const rootReducer = combineReducers({
    authentication: persistReducer<any, any>(authenticationPersistConfig, authenticationReducer)
    , tab: persistReducer<any, any>(tabPersistConfig, tabReducer)
    , users: usersReducer
    , user: userReducer
    
    // associations reduce
    , associationsList: associationsListReducer
    , association: associationReducer

    // MembershipRequests reduce
    , smr: smrReducer
    , bmr: bmrReducer
    

    // MembershipStock reduce
    , bms: bmsReducer
    
    , settings: persistReducer<any, any>(settingsPersistConfig, settingsReducer)

    , search: persistReducer<any, any>(searchPersistConfig, searchReducer)
    
})


const persistedRootReducer = persistReducer<any, any>(rootPersistConfig, rootReducer)


export const store = configureStore({
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER
                ],
                ignoredActionPaths: [
                    'meta.arg',
                    'payload.timestamp',
                ],
                ignoredPaths: [
                    
                ],
            },
        }), //.concat(thunk),
  reducer: rootReducer, // persistedRootReducer,
})


// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
